import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree,
  CanActivateChild
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { UserService } from '../services/user-service.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileCompleteGuard implements CanActivateChild {

  constructor(
    private userService: UserService,
    private router: Router
  ) { }


  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if (route.data['skipProfileGuard']) {
      return true;
    }

    // First check from session storage
    const user = this.userService.getUserDetails();

    if (user && user.isProfileCompleted !== undefined) {
      if (!user.isProfileCompleted) {
        return this.router.createUrlTree(['/user/profile']);
      }
      return true;
    }

    // If not in session, fetch from API
    return this.router.createUrlTree(['/auth/login']);
  }
}

